export const SALE_RIBBON = 'SALE_RIBBON';
